import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import VehicleCategoryForm from './VehicleCategoryForm';

//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { productTypeValidationForm } from '../../utils/validationSchemas';

const EditVehicleCategory= (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(productTypeValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch()
      return {
        ...data?.data
      }
    }
  });
  const { handleEdit, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <VehicleCategoryForm
        errors={errors}
        register={register}
      />
    </FormLayout>

  );
}

export default EditVehicleCategory
